import { Link } from "react-router-dom";
import styled from "styled-components";

interface ExtendProps {
  extendNavbar: boolean;
}

export const Container = styled.header`
  height: ${({ extendNavbar }: ExtendProps) => (extendNavbar ? "100vh" : "")};
`;

export const Content = styled.div`
  max-width: 1220px;
  margin: 0 auto;

  padding: 2rem 1rem 8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .change-state-buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .theme {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 40px;
    width: 40px;
    background: none;
    border: none;
    border-radius: 50px;

    transition-duration: 0.3s;

    &:hover {
      border-radius: 8px;
      background: rgba(128,128,128,.2);
    } 
  }

  .language {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;

    height: 40px;
    width: 40px;
    border: none;
    border-radius: 50px;

    transition-duration: 0.3s;

    &:hover {
      background: rgba(128,128,128,.2);
      border-radius: 8px;
    } 
  }
  
  p {
    color: ${props => props.theme["text-title"]}
  }
`;


//-----------------------------------------------------------------
// nav options

export const OpenLinksButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  
  width: 70px;
  height: 50px;
  background: none;
  border: none;
  color: ${props => props.theme["text-title"]};
  font-size: 45px;
  cursor: pointer;

  @media (min-width: 940px) {
    display: none;
  }
`;

export const LinksContainer = styled.div`
  width: 50%;
  padding: 2rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 2rem;

  @media (max-width: 939px) {
    display: none;
  }
`;

export const NavbarLinkContainer = styled.div`
  display: flex;
`;

export const NavbarLink = styled(Link)`
  color: ${props => props.theme["text-body"]};
  font-size: 1.2rem;
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  text-decoration: none;

  transition: filter 0.2s;

    &:hover {
      filter: brightness(200%);
      font-weight: 500;
      cursor: pointer;
    }
`;

export const NavbarLinkExtended = styled(Link)`
  color: ${props => props.theme["text-body"]};
  font-size: x-large;
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  text-decoration: none;
  margin: 10px;

  transition: filter 0.2s;

    &:hover {
      filter: brightness(200%);
      font-weight: 500;
      cursor: pointer;
    }
`;

export const NavbarExtendedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  transition-duration: 2s;

  @media (min-width: 940px) {
    display: none;
  }

  @keyframes inAnimation {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
`;